import type { BrandId } from "@/lib/data/services";

export type Capability = {
  /** Short verb shown above the title, e.g. ACTIVATE. */
  kicker: string;
  title: string;
  detail: string;
  href: string;
  icon: "target" | "graph" | "gauge" | "ai" | "layer";
  marks?: BrandId[];
};

/** The hero rail: what DBM does, in the order a client experiences it. */
export const capabilities: Capability[] = [
  {
    kicker: "Activate",
    title: "Pipeline Opportunity",
    detail: "Turn Google Ads spend into qualified pipeline, not form fills.",
    href: "/services/ppc-management",
    icon: "target",
    marks: ["google"],
  },
  {
    kicker: "Measure",
    title: "Outcome reporting",
    detail: "Connect spend to CRM or ATS data so marketing maps to real business outcomes.",
    href: "/services/revenue-measurement",
    icon: "graph",
  },
  {
    kicker: "Operate",
    title: "The DBM Platform",
    detail: "Detect performance changes, prioritize actions, and keep investment on plan.",
    href: "/platform",
    icon: "gauge",
  },
  {
    kicker: "Monitor",
    title: "AI visibility monitor",
    detail: "See how AI engines describe, cite, and compare your brand.",
    href: "/platform/llm-performance-monitor",
    icon: "ai",
    marks: ["chatgpt", "gemini", "perplexity", "copilot", "google"],
  },
];
